import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import socket from '../utils/socket';
import { useUser } from '../utils/hook/UserContext';
import { registerWebPush } from '../utils/webpush';

function SocketManager() {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.id) {
      return;
    }

    const userId = user.id;

    const registerUser = () => {
      socket.emit('register', userId);
    };

    socket.on('connect', registerUser);

    if (!socket.connected) {
      socket.connect();
    } else {
      registerUser();
    }

    const handlePushNotification = ({ title, body, link }) => {
      if (link && window.location.pathname === link) {
        return;
      }

      if ('Notification' in window && Notification.permission === 'granted') {
        const notification = new Notification(title, {
          body,
          icon: '/logo192.png',
        });

        notification.onclick = () => {
          window.focus();

          if (link) {
            navigate(link);
          }
        };
      }
    };

    socket.on('push-notification', handlePushNotification);

    registerWebPush(userId);

    return () => {
      socket.off('connect', registerUser);
      socket.off('push-notification', handlePushNotification);
    };
  }, [user?.id, navigate]);

  return null;
}

export default SocketManager;
